var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFocus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.063 3.125h2.812v2.813m-2.812 10.937h2.812v-2.813M5.938 16.875H3.124v-2.813M5.938 3.125H3.124v2.813M10 11.25a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m-3.75 1.875a4.687 4.687 0 0 1 7.5 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFocus);
export default __webpack_public_path__ + "static/media/userFocus.871bcbaa155d1abac6b7eb720c7d1bde.svg";
export { ForwardRef as ReactComponent };